module.exports = __webpack_public_path__ + "fonts/bpmn.f922519e.ttf";